// IMPORTANTE: Las variables de entorno en React deben empezar con REACT_APP_
// Si cambias el .env, DEBES reiniciar el servidor de desarrollo (npm start)

// URL del backend
// En producción se usa el mismo origen HTTPS de la aplicación. Nginx reenvía
// /api al contenedor de la API, evitando contenido mixto y CORS innecesario.
export const baseURLForzada =
  process.env.NODE_ENV === 'production'
    ? ''
    : (process.env.REACT_APP_BACKEND_URL || 'http://localhost:8800');

// Debug: Ver qué URL se está usando (solo en desarrollo)
if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
  console.log('🔗 Backend URL configurada:', baseURLForzada);
  console.log('🔍 REACT_APP_BACKEND_URL:', process.env.REACT_APP_BACKEND_URL);
}

// Las rutas se resuelven contra el mismo origen en producción.
export const urlAmenazas = `${baseURLForzada}/api/amenazas`;
export const urlTipoAmenaza = `${baseURLForzada}/api/tipoamenaza`;
export const urlDimensionValoracion = `${baseURLForzada}/api/dimensionvaloracion`;
export const urlAuthentication = `${baseURLForzada}/api`;
export const urlTipoVulnerabilidad = `${baseURLForzada}/api/tiposvulnerabilidad`;
export const urlTiposActivos = `${baseURLForzada}/api/tiposactivos`;
export const urlContramedidas = `${baseURLForzada}/api/contramedidas`;
export const urlVulnerabilidades = `${baseURLForzada}/api/vulnerabilidades`;
export const urlTiposVulnerabilidad = `${baseURLForzada}/api/tiposvulnerabilidad`;
export const urlProbabilidad = `${baseURLForzada}/api/probabilidad`;
export const urlUnidades = `${baseURLForzada}/api/unidades`;
export const urlActivos = `${baseURLForzada}/api/activos`;
export const urlValorImpacto = `${baseURLForzada}/api/valorimpacto`;
export const urlAmenazasVulnerabilidades = `${baseURLForzada}/api/amenazasvulnerabilidades`;
export const urlVulnerabilidadActivo = `${baseURLForzada}/api/activo-vulnerabilidad`;
export const urlActivoVulnerabilidadAmenaza = `${baseURLForzada}/api/activo-vulnerabilidad-amenaza`;
export const urlVulnerabilidadContramedida = `${baseURLForzada}/api/vulnerabilidad/contramedidas`;
export const urlValoracion = `${baseURLForzada}/api/valoracion`;
export const urlEmpresas = `${baseURLForzada}/api/empresas`;
